export const messages = {
  error: {
    fetchResultsFailure:
      "We are sorry. We are having technical problems. For more help or to report the problem, please call: 877-ASKFDIC (877-275-3342) 800-925-4618 Hours of Operation 8:00 am - 8:00 pm ET Monday - Friday 9:00 am - 5:00 pm ET Saturday - Sunday",
    invalidFieldFailure:
      "Invalid display fields supplied in web browser address, please check URL and try again.",
  },
  information: {
    noRecordsToDisplay: "There are no Records to Display",
    usDollarInThousands: "Numbers represent thousands of US Dollars",
  },
  intro: {
    historical:
      "The Historical Bank Data is the annual summary of financial and structure data for all FDIC-insured institutions. The data can be used to identify and analyze long term trends and to develop benchmarks to evaluate the current conditions of the banking and thrift industries. This annual data is available from 1934 to 2017.",
    failures:
      "The Bank Failure and Assistance Data provides a complete look at bank failures and assistance transactions of FDIC-insured institutions from 1934 to the present. The data is updated after a bank failure or assistance transaction.",
  },
  datePicker: {
    startDateMin: "Start Date can not be before Aug 1, 1999",
    financialStartDateMin: "Start Date can not be before Jan 1, 1792",
    inactiveStartDateMin: "Start Date can not be before Jan 1, 1970",
    startDateMaxCurrent: "Start Date can not be after current date",
    startDateMaxEnd: "Start Date can not be after End Date",
    endDateMinDefault: "End Date can not be before Aug 1, 1999",
    financialEndDateMinDefault: "End Date can not be before Jan 1, 1792",
    inactiveEndDateMinDefault: "End Date can not be before Jan 1, 1970",
    endDateMinStart: "End Date can not be before Start Date",
    endDateMax: "End Date can not be after current date",
  },
};
